export const parseInviteEmail = (search = "") => {
  const query = String(search || "");
  const params = new URLSearchParams(query.startsWith("?") ? query.slice(1) : query);
  return String(params.get("email") || "").trim();
};

export const isInvitePasswordValid = (checks) =>
  Boolean(
    checks?.length
    && checks?.number
    && checks?.specialSymbal
    && checks?.allowedChars
    && checks?.lowerLetter
    && checks?.upperLetter
  );
